// extracted by mini-css-extract-plugin
export var cardHeader = "_t8-0";
export var reorderHandle = "_t8-3";
export var titleArea = "_t8-1";
export var titleAreaWithHandle = "_t8-2";